import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getHtmlStatement, CARD_GET_HTML_STATEMENT} from './redux';
import {actionPending, actionFail} from 'utils/redux/thunkActionHelpers';
import LoadingBlocking from 'components/loading/LoadingBlocking';
import DocumentFailure from './DocumentFailure';
import ImageViewer from "./ImageViewer";
import {datadogRum} from "@datadog/browser-rum";
import {FileFormat} from "../services/api/dto/fileFormat";

@connect(
  (state, ownProps) => {
    return {
      fileDate: ownProps.params.fileDate,
      document: state.document.htmlStatement,
      actionType: state.document.type,
      actionStatus: state.document.status,
    };
  },
  dispatch => (bindActionCreators({getHtmlStatement}, dispatch))
)
export default class HtmlStatementController extends React.Component {

  constructor(props) {
    super(props);
  }

  static propTypes = {
    fileDate: PropTypes.string.isRequired,
    document: PropTypes.object,
    actionType: PropTypes.string,
    actionStatus: PropTypes.string,
    getHtmlStatement: PropTypes.func,
  };

  componentDidMount() {
    this.setState((prevState) => {
      return {
        ...prevState,
      };
    });
    this.props.getHtmlStatement(this.props.fileDate);
  }

  renderComponent = () => {
    if (!this.props.document.content) {
      datadogRum.addUserAction('Document fetch failed', {documentFormat: FileFormat.HTML, fileDate: this.props.fileDate});
      return <DocumentFailure/>;
    }

    datadogRum.addUserAction('Document fetch Success', {documentFormat: FileFormat.HTML, fileDate: this.props.fileDate});
    return (<ImageViewer fileFormat="JPEG" content={this.props.document.content} />);
  };

  render() {
    if (!this.props.actionStatus || actionPending(CARD_GET_HTML_STATEMENT, this.props.actionType, this.props.actionStatus)) {
      return (<LoadingBlocking />);
    }

    if (actionFail(CARD_GET_HTML_STATEMENT, this.props.actionType, this.props.actionStatus)) {
      return <DocumentFailure />;
    }

    return this.renderComponent();

  }
}



// WEBPACK FOOTER //
// ./src/pdf/DocumentHtmlStatmentController.js